/**
 *
 * @param {object[]} empleados
 * @param {string} accion
 * @returns {object[]}
 */
export const asignarEmpleadosReducer = (empleados = [], accion) => {
    if (accion.tipo == "agregar") {
        let empleadosAgregados = 0;

        accion.valor.forEach((empleado) => {
            const empleadoEncontrado = empleados.find(
                (empl) => empl.persona_id == empleado.persona_id
            );

            if (empleadoEncontrado != null) return;
            empleado.nomina_secuencia_id = accion.idSecuencia;
            empleado.posicion_arranca_secuencia = 0;
            empleados.push(empleado);
            empleadosAgregados++;
        });

        // Si no se agregó ningún empleado, se retorna el array pasado
        // Para evitar que la vista se re-renderice innecesariamente.
        return empleadosAgregados > 0 ? [...empleados] : empleados;
    } else if (accion.tipo == "seleccionar_turno") {
        let cambioDeTurno = false;

        empleados.forEach((empleado) => {
            if (
                empleado.persona_id == accion.idEmpleado &&
                empleado.posicion_arranca_secuencia != accion.indiceTurno
            ) {
                cambioDeTurno = true;
                empleado.posicion_arranca_secuencia = accion.indiceTurno;
            }
        });

        // Si no se cambió de turno al empleado, se retorna el array pasado
        // Para evitar que la vista se re-renderice innecesariamente.
        return cambioDeTurno ? [...empleados] : empleados;
    } else if (accion.tipo == "llenar") {
        return accion.valor ?? [];
    } else if (accion.tipo == "eliminar") {
        return empleados.filter(
            (empleado) => empleado.persona_id != accion.valor
        );
    }

    return empleados;
};
